export const COMMUNICATION_HISTORY_TABS = {
	EMAIL: 'email',
	SMS: 'sms',
} as const;

export type TCommunicationHistoryTab =
	(typeof COMMUNICATION_HISTORY_TABS)[keyof typeof COMMUNICATION_HISTORY_TABS];
